import type { ReactElement } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
/** @sfdc-extension-line SNK */
import { BURGER_MENU_CONTENT_SLOTS_MAX_WIDTH_CLASS } from '@/extensions/snk/lib/utils';

const NAV_ROW_COUNT = 8;
const TRENDING_ITEM_COUNT = 4;
const FOOTER_LINK_COUNT = 4;

export const BurgerMenuTrendingSkeleton = (): ReactElement => (
    <div aria-hidden="true" className="space-y-4 px-4 pt-6" data-testid="burger-menu-trending-skeleton">
        <Skeleton className="h-5 w-32" />
        <div className="flex gap-4 overflow-hidden">
            {Array.from({ length: TRENDING_ITEM_COUNT }, (_, index) => (
                <Skeleton key={`trending-${index}`} className="size-20 shrink-0 rounded-full" />
            ))}
        </div>
    </div>
);

export const BurgerMenuSkeleton = (): ReactElement => (
    <>
        <BurgerMenuTrendingSkeleton />
        <div aria-hidden="true" className="mt-2 space-y-0">
            {Array.from({ length: NAV_ROW_COUNT }, (_, index) => (
                <Skeleton key={`nav-${index}`} className="h-14 w-full rounded-none" />
            ))}
        </div>
    </>
);

export const BurgerMenuSubmenuContentSkeleton = (): ReactElement => (
    <div
        aria-hidden="true"
        className="flex flex-col gap-4 px-4 py-4"
        data-testid="burger-menu-submenu-content-skeleton">
        <Skeleton className="aspect-[4/3] w-full rounded-none" />
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-8 w-3/4" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-10 w-32" />
    </div>
);

export const BurgerMenuFooterSkeleton = (): ReactElement => (
    <div
        aria-hidden="true"
        className={`flex shrink-0 flex-col gap-3 border-t border-border px-4 py-4 ${BURGER_MENU_CONTENT_SLOTS_MAX_WIDTH_CLASS}`}>
        <Skeleton className="h-5 w-40" />
        {Array.from({ length: FOOTER_LINK_COUNT }, (_, index) => (
            <Skeleton key={`footer-${index}`} className="h-8 w-48" />
        ))}
    </div>
);
